/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAlert } from '../../../Common/hooks';
import { getProcedureFilters } from '../../selectors';
import { getProcedureReports } from '../../services';
import { proceduresError } from '../../services/constants';

const useProcedureReport = () => {
  const filters = useSelector(getProcedureFilters);
  const { showAlert } = useAlert();
  const [procedureReports, setProcedureReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFilterChange = async () => {
    if (filters.aggregatorID && filters.payerID) {
      setIsLoading(true);
      const procedureCodes = await getProcedureReports(filters);
      if (procedureCodes.length === 0) {
        showAlert({ color: 'error', icon: 'exclamation', message: proceduresError });
      }

      setProcedureReports(procedureCodes);
      setIsLoading(false);
    } else {
      setProcedureReports([]);
    }
  };

  useEffect(() => {
    handleFilterChange();
  }, [filters]);

  return {
    procedureReports,
    isLoading,
  };
};

export default useProcedureReport;
